import SalesByTypesAndTime from './SalesByTypesAndTime'

export default {
  list: SalesByTypesAndTime,
}
